import React from 'react';
import { useIntl } from 'react-intl';

import { useFlag } from 'utils/launchdarkly';

import { CancellationPolicyText, Title, Wrapper } from './delivery-cancellation-policy.styled';

export default () => {
  const { formatMessage } = useIntl();
  const isEnabled = useFlag('enable-delivery-cancellation-policy');
  if (!isEnabled) {
    return null;
  }
  return (
    <Wrapper>
      <Title>{formatMessage({ id: 'cancellationPolicyTitle' })}</Title>
      <CancellationPolicyText>{formatMessage({ id: 'cancellationPolicy' })}</CancellationPolicyText>
    </Wrapper>
  );
};
